const initialState = {
  activeData: null,
  signOnOffData: null,
  projects: null,
  hauls: null,
  drivers: null,
  loading: true,
  updatedDt: null,
  filters: { hauls: [], projects: [] }
}

export default initialState
